import { useState, memo } from 'react';
import { ExpandMore as ExpandMoreIcon, MailOutline as MailOutlineIcon } from '@material-ui/icons';
import { withStyles, Popper, Button, Paper, Fade } from '@material-ui/core';
import styles from '../../../../../../layout/layoutHeader/components/styles';

const Messages = ({ eventHub, classes }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  const closePopover = () => {
    setAnchorEl(null);
  };

  const openGroupMessage = () => {
    eventHub.emit('openDriverGridModel', 'isDispatchGroupMsgPopupOpen');
    closePopover();
  };

  const openMessageHistory = () => {
    eventHub.emit('openDriverGridModel', 'openMessageHistory');
    closePopover();
  };

  return (
    <span
      onMouseLeave={handleMouseLeave}
      className={`${classes.headerIconStyles} ${classes.iconLayout}`}>
      <div className={classes.messageContainer} onMouseEnter={handleMouseEnter}>
        <MailOutlineIcon /> <ExpandMoreIcon />
      </div>
      <Popper
        id="messages"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={closePopover}
        transition
        className={classes.customPopper}
        placement="bottom">
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper className={classes.menuContainer}>
              <Button onClick={openGroupMessage} className={classes.menuLabel}>
                Group Message
              </Button>
              <Button onClick={openMessageHistory} className={classes.menuLabel}>
                Message History
              </Button>
            </Paper>
          </Fade>
        )}
      </Popper>
    </span>
  );
};

export default withStyles(styles)(memo(Messages));
